import { FormattedMessage, useIntl } from 'react-intl';
import SnackBar from 'client/components/ui/Snackbar/SnackBar';
import { mdiClose } from '@mdi/js';
import Button from 'client/components/aria/Button/Button';
import Icon from '@mdi/react';
import { useMemo } from 'react';
import styles from './PdfsDisabledSnackBar.module.scss';
import { useSnackBarState } from './useSnackbarState';

const PdfsDisabledSnackBar = () => {
    const intl = useIntl();
    const { isOpen, dismiss } = useSnackBarState();

    const closeButton = useMemo(() => <Button
        aria-label={intl.formatMessage({ id: 'close' })}
        data-testid="pdfsDisabledSnackBar.close"
        variant="transparent"
        className={styles.button}
        onPress={dismiss}
    >
        <Icon path={mdiClose} size={1}/>
    </Button>, [dismiss, intl]);

    return (
        isOpen
            ? <SnackBar variant="warning" endOfLine={closeButton} data-testid="pdfsDisabledSnackBar">
                <FormattedMessage
                    id={'mapPage.pdfsDisabled'}
                />
            </SnackBar>
            : null
    );
};

export default PdfsDisabledSnackBar;
